import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<void>>;

const removeAthleteFromPod = (organizationUuid: string, selectedPodUuid: string): ReturnType => {
    return Request.post(`organizations/${organizationUuid}/pods/${selectedPodUuid}/remove-athlete`);
};

export { removeAthleteFromPod };
